import { PiInfinity } from 'react-icons/pi';
import { EMPTY_VALUE_PLACEHOLDER } from '../../const/system';
import React from 'react';
import PropTypes from "prop-types";



const EmptyReleasedTo = ({ isPublished }) => {
  return isPublished ? <PiInfinity/> : <span>{ EMPTY_VALUE_PLACEHOLDER }</span>;
};

EmptyReleasedTo.propTypes = {
  isPublished: PropTypes.bool,
}

export default EmptyReleasedTo;
